import { getServiceUrl } from '../api.config';
import { ApiClientOptions } from '../types/api';
import ApiClient from '../utils/ApiClient';
import qs from '../utils/query';
import {
  isArray,
  isBoolean,
  isNotEmptyString,
  isPositiveInteger,
} from '../utils/validators';

export default class SegmentHierarchyApi extends ApiClient {
  public constructor(options?: ApiClientOptions) {
    super(getServiceUrl('core'), options);
  }

  public create({ name, shortId, organizationId, parentId }: any) {
    const query = '/core/v3/productsegments/hierarchy';
    return this.post(query, {
      name,
      organization: { id: organizationId },
      parent: { id: parentId },
      shortId,
    });
  }

  public update({ id, name, parentId }: any) {
    const query = `/core/v3/productsegments/hierarchy/${id}`;
    return this.put(query, {
      id,
      name,
      parent: { id: parentId },
    });
  }

  public list({ queries = {}, offset, limit, useCache = true }: any = {}) {
    const query = '/core/v3/productsegments/hierarchy';
    const params: any = {};
    if (isNotEmptyString(queries.name)) {
      params.filter_name_like = queries.name;
    }
    if (isBoolean(queries.statistics)) {
      params.with_product_counts = queries.statistics;
    }
    if (isBoolean(queries.tree)) {
      params.as_tree = queries.tree;
    }
    if (isPositiveInteger(offset)) {
      params.offset = offset;
    }
    if (isPositiveInteger(limit)) {
      params.limit = limit;
    }
    if (isBoolean(queries.withUnclassified)) {
      params.with_unclassified = queries.withUnclassified;
    }
    if (isArray(queries.ids)) {
      params.filter_id_in = queries.ids;
    }

    return this.get(query, qs.stringify(params, true), useCache);
  }

  public tree({ queries = {}, useCache = true }: any) {
    const query = '/core/v3/productsegments/hierarchy/tree';
    const params: any = {};

    if (isNotEmptyString(queries.productPermission)) {
      params.product_permission = queries.productPermission;
    }
    if (isNotEmptyString(queries.nameLike)) {
      params.filter_name_like = queries.nameLike;
    }
    if (isArray(queries.ids)) {
      params.filter_id_in = queries.ids;
    }

    return this.get(query, qs.stringify(params, true), useCache);
  }

  public deleteMultiple({ ids }: any) {
    const query = '/core/v3/productsegments/hierarchy';
    return this.delete(query, {
      productsegment_ids: ids,
    });
  }

  public move({ ids, toParentId }: any) {
    const query = '/core/v3/productsegments/hierarchy/move';
    return this.post(query, {
      parent_id: toParentId,
      productsegment_ids: ids,
    });
  }

  public attachProducts({ productSegmentId, productIds, productKeyIds }: any) {
    const query = `/core/v3/productsegments/hierarchy/${productSegmentId}/products/add`;
    return this.post(query, {
      product_ids: productIds,
      product_key_ids: productKeyIds,
    });
  }

  public detachProducts({ productIds, productKeyIds }: any) {
    const query = '/core/v3/productsegments/hierarchy/products/remove';
    return this.post(query, {
      product_ids: productIds,
      product_key_ids: productKeyIds,
    });
  }
}
